import React from "react";
import API_URL from '../config';
import generarDeclaracionPDF from './generarDeclaracionPDF';
import { MDBContainer, MDBCol, MDBRow } from "mdbreact";
import axios from 'axios';
import PanelDatosPersonales from './declaraciones/PanelDatosPersonales';
import SelectorDeclaracion from './declaraciones/SelectorDeclaracion';
import PanelFirmaDigital from './declaraciones/PanelFirmaDigital';

class DeclaracionesJuradas extends React.Component{
  //metodo contructor
  constructor(props){
    super(props)
    this.state = {
      datosPersonales:[],
      informacionregistro:[],
      codigodetrabajador:'',
      periodos:[],
      condicionesLaborales:[],
      planillasTrabajador:[],
      boletapdf:[],
      modal1: false,
      modal2: false,
      modal3: false,
      periodoActual:'',
      planillaActual:'',
      usuario:'',
      autorizacion:'',
      file: '',
      msg: '',
      direcciondearchivo: false,
      descargardocumento: false,
      calendarioActivo: null,
      calendariosActivos: [],
      calendarioSeleccionadoIdx: 0,
      archivoPreview: null,
      pdfPreviewUrl: null,
      pdfFirmadoUrl: null,
      yaFirmadoDB: false,
      firmando: false,
      errorFirma: null
    };
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////para subir archivos
  onFileChange = (event) => {
    var archivo = event.target.files[0];
    if (!archivo) {
      this.setState({ file: '', archivoPreview: null,
      pdfPreviewUrl: null });
      return;
    }
    if (archivo.type !== 'application/pdf') {
      this.setState({ file: '', archivoPreview: null,
      pdfPreviewUrl: null, error: 'Solo se permiten archivos PDF.', msg: '' });
      return;
    }
    var previewUrl = URL.createObjectURL(archivo);
		this.setState({ file: archivo, archivoPreview: previewUrl, msg: '', error: null });
	}

  cancelarPreview = () => {
    if (this.state.archivoPreview) URL.revokeObjectURL(this.state.archivoPreview);
    this.setState({ file: '', archivoPreview: null,
      pdfPreviewUrl: null, msg: '', error: null });
    var input = document.getElementById('myFile');
    if (input) input.value = '';
  }

  uploadFileData = (event) => {
		event.preventDefault();
    if (!this.state.file || !this.state.archivoPreview) return;
		this.setState({msg: ''});

		let data = new FormData();
		data.append('file', this.state.file);
    //data.append('codigoRaiz', 'xxxxxxxx');
    /////////////////////////////////////////////////////////////////////////////////////            
    //console.log('yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy');
    //console.log(this.state.file);

    //console.log(data);
		fetch(API_URL + '/uploadfile', {
      method: 'POST',
			body: data,
      headers: { 'usuario': this.usuarioDato ? this.usuarioDato.value : '', 'anio': (this.state.calendarioActivo && this.state.calendarioActivo.anio) || '', 'documento': (this.state.calendarioActivo && this.state.calendarioActivo.documento) || '' }
		}).then(response => {
      if (this.state.archivoPreview) URL.revokeObjectURL(this.state.archivoPreview);
			this.setState({msg: "ok", error: null, archivoPreview: null,
      pdfPreviewUrl: null});
		}).catch(err => {
			this.setState({error: err, msg: ''});
		});

  ////////////////////////// Registrar el archivo subido  
  //GUARDAR EL ARCHIVO SUBIDO
  var datos = this.state.condicionesLaborales.filter((fila)=>{
    return (!fila.trabajador || fila.trabajador.toString().trim() === "")
  })
  var  anioda =  datos.length > 0 ? datos[0].aniod : '';
  var  documentoda =  datos.length > 0 ? datos[0].documentod : '';
  var  nombreda =  datos.length > 0 ? (datos[0].nombred || datos[0].nombre || datos[0].Nombre) : '';

  // Registrar usando calendario activo directamente
  var codigoTrabajador = this.usuarioDato ? this.usuarioDato.value : '';
  if (!codigoTrabajador) return;
  axios.post(API_URL + '/webguardarRegistroArchivoActivo/' + codigoTrabajador)
      .then((response) => {
        //this.setState({ informacionregistro : response.data})

        if(response.data.length>0){
          this.setState({ informacionregistro : response.data})
          this.setState({direcciondearchivo: false});
          this.setState({descargardocumento: false});
          this.setState({file: ''});
          }
          else
          {
            this.setState({ informacionregistro : []})
            this.setState({direcciondearchivo: true});
            this.setState({descargardocumento: true});
            this.setState({file: ''});
          }
      }
      )
      .catch()

	}

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  //metodo par amostrar modal
  toggle = nr => () => {
    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber]
    });
  };

  ///////////////////////////////////////////
  //////////////////////////////////////////
  //EVENTO DE CONDICION LABORAL
  // Verifica si la condicion seleccionada esta habilitada para el calendario activo
  condicionHabilitada=(trabajadorValue)=>{
    var cal = this.state.calendarioActivo;
    if (!cal || !cal.observacion) return true; // si no hay calendario o no tiene observacion, permitir
    var condicion = null;
    for (var i = 0; i < this.state.condicionesLaborales.length; i++) {
      if (String(this.state.condicionesLaborales[i].trabajador) === String(trabajadorValue)) {
        condicion = this.state.condicionesLaborales[i];
        break;
      }
    }
    if (!condicion || !condicion.nombre) return false;
    // nombre tiene formato "DOA-DOCENTE ORDINARIO" -> extraer tipoplanilla antes del guion
    var tipoPlanilla = condicion.nombre.split('-')[0].trim();
    var obsCalendario = cal.observacion.trim();
    // observacion puede contener un tipo o varios separados por coma
    var tiposHabilitados = obsCalendario.split(',').map(function(t){ return t.trim(); });
    return tiposHabilitados.indexOf(tipoPlanilla) >= 0;
  }

  listarCondicionLaboral=(event)=>{
    event.preventDefault();  

    var miInituno = {
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': '99999'
      },
      body: JSON.stringify({
        usuario: this.usuarioDato.value,
     })
     };
    const usuarioActuald = event.target.value;
    axios.post(API_URL + '/vinculopdfuno/', miInituno)
        .then((response) => {
          this.setState({ datosPersonales : response.data})
        } 
        )
        .catch()

    // Verificar si la condicion seleccionada esta habilitada para el calendario activo
    if (!this.condicionHabilitada(this.usuarioDato.value)) {
      this.setState({ informacionregistro : [], direcciondearchivo: false, descargardocumento: false });
      return;
    }

       //RECUPERAMOS DATOS DE CALENDARIO
        var datos = this.state.condicionesLaborales.filter((fila)=>{
          return (!fila.trabajador || fila.trabajador.toString().trim() === "")
        })
        var  aniod =  datos.length > 0 ? datos[0].aniod : '';
        var  documentod =  datos.length > 0 ? datos[0].documentod : '';
        var  nombred =  datos.length > 0 ? datos[0].nombred : '';

    if (aniod && documentod) {
    axios.post(API_URL + '/webrecuperarRegistroArchivo/'+this.usuarioDato.value+'/'+aniod+'/'+documentod)
        .then((response) => {
          if(response.data.length>0){
            this.setState({ informacionregistro : response.data}); 
            this.setState({direcciondearchivo: false});
            this.setState({descargardocumento: false});
          }
          else
          {
            this.setState({ informacionregistro : []});
            this.setState({direcciondearchivo: true});
            this.setState({descargardocumento: true});
          }
        } 
        )
        .catch()
    } else {
      this.setState({ informacionregistro : []});
      this.setState({direcciondearchivo: true});
      this.setState({descargardocumento: true});
    }
        
  }

  ///////////////////////////////////////////
  //////////////////////////////////////////
  //EVENTO para listar las las planillas existentes en un periodo determinado
  listarPlanillasPorPeriodo=(event)=>{
    event.preventDefault(); 
    //const planillaActuald = this.tipoDePlanillaDato.value; 

    // //console.log('entro a  recuperar periodos');
    // var miInitt = { 
    //   method: 'post',
    //   credentials: 'same-origin',
    //   headers: {
    //     'X-Requested-With': 'XMLHttpRequest',
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json',
    //     'Authorization': '99999'
    //   },
    //   body: JSON.stringify({
    //     periodo: event.target.value,
    //     usuario: this.state.usuario,
    //     autorizacion:this.state.autorizacion
    //  })
    //  }; 
    // /////////////////////////////////////////////
    // const periodoActuald = event.target.value;

    // axios.post(API_URL + '/planillastrabajadorperiodo/', miInitt)
    //     .then((response) => {
    //       this.setState({ planillasTrabajador : response.data})
    //       this.setState({ periodoActual : periodoActuald})
	  // this.setState({ boletapdf : []})
    //     } 
    //     )
    //     .catch()                                            
  }

  /////////////////////////////////////////////////////
  ////////////////////////////////////////////////////
  //metodo para  recuperar el detalle de las planillas
  acceder=(event)=>{
    event.preventDefault();   
    //console.log('entro a  recuperar detalles de la planilla'); 
    //console.log(this.periodoDato.value);
    //console.log(this.tipoDePlanillaDato.value);
    const planillaActuald = this.tipoDePlanillaDato.value;

    var miInittt = { 
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': '99999'
      },
      body: JSON.stringify({
        usuario: this.state.usuario,
        periodo: this.periodoDato.value,
        tipoplanilla:this.tipoDePlanillaDato.value
     })
     }; 
    
    //axios.get(API_URL + '/boletapdf/'+ this.state.usuario+'/'+this.periodoDato.value +'/'+this.tipoDePlanillaDato.value+'/')
    axios.post(API_URL + '/boletapdf/', miInittt)
        .then((response) => {
          this.setState({ boletapdf : response.data})
          this.setState({ planillaActual : planillaActuald})
        }
        )
        .catch()      
  }

////////////////////////////////////////////////////////////////////
///////////////PARA GENERAR PDF ////////////////////////////////////
accederPDF=(event)=>{
  event.preventDefault();
  var blobUrl = generarDeclaracionPDF(this.state.datosPersonales, this.state.calendarioActivo);
  this.setState({ pdfPreviewUrl: blobUrl });
}

firmarDocumento = () => {
  this.setState({ firmando: true, errorFirma: null });
  var pdfBase64 = generarDeclaracionPDF(this.state.datosPersonales, this.state.calendarioActivo, 'base64');
  var datosDni = this.state.datosPersonales.filter(function(f){ return f.descripcion === 'Dni'; });
  var dni = datosDni.length > 0 ? datosDni[0].nombre : '';
  var codigoTrabajador = this.usuarioDato ? this.usuarioDato.value : '';
  var cal = this.state.calendarioActivo || {};
  var autorizacion = (this.props.location && this.props.location.state && this.props.location.state.datos && this.props.location.state.datos[0]) ? this.props.location.state.datos[0].autorizacion : '';

  // El backend hace la llamada al servicio de firma (evita restriccion CORS del navegador)
  axios.post(API_URL + '/firma/firmar/',
    { pdfBase64: pdfBase64, dni: dni, anio: cal.anio, documento: cal.documento },
    { headers: { authorization: autorizacion }, timeout: 120000 }
  )
    .then((firmaRes) => {
      if (!firmaRes.data || !firmaRes.data.ok) throw new Error(firmaRes.data && firmaRes.data.error ? firmaRes.data.error : 'Error en firma digital');
      var pdfFirmadoBase64 = firmaRes.data.data;
      return axios.post(API_URL + '/firmardeclaracion/',
        {
          pdfFirmado: pdfFirmadoBase64,
          codigoTrabajador: codigoTrabajador,
          anio: cal.anio,
          documento: cal.documento,
          rutaDocumentoFirmado: firmaRes.data.rutaDocumentoFirmado || null,
          idDocumentoFirmar: firmaRes.data.idDocumentoFirmar || null
        },
        { headers: { authorization: autorizacion } }
      );
    })
    .then((saveRes) => {
      if (saveRes.data && saveRes.data.ok) {
        var pdfBytes = Uint8Array.from(atob(saveRes.data.pdfFirmado), function(c){ return c.charCodeAt(0); });
        var pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
        var pdfFirmadoUrl = URL.createObjectURL(pdfBlob);
        this.setState({ pdfFirmadoUrl: pdfFirmadoUrl, firmando: false });
      } else {
        this.setState({ firmando: false, errorFirma: 'Error al guardar el documento firmado.' });
      }
    })
    .catch((e) => {
      var msg = (e.response && e.response.data && e.response.data.error) ? e.response.data.error : (e.message || 'Error de conexion al servicio de firma.');
      this.setState({ firmando: false, errorFirma: msg });
    });
}
////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////

  //metodo render
  //metodo render
  render(){
    const hasRegistros = this.state.informacionregistro && this.state.informacionregistro.length > 0;

    return(
      <MDBContainer className="mt-4">

        {/* Titulo principal */}
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <h4 style={{ fontWeight: '700', color: '#7A1622', marginBottom: '4px', fontSize: '1.4rem' }}>
            <i className="fas fa-file-signature mr-2"></i>Presentacion de Declaracion Jurada
          </h4>
          <p style={{ color: '#666', fontSize: '0.85rem', margin: 0 }}>Firme digitalmente su declaracion desde esta pagina, sin necesidad de imprimir ni escanear</p>
        </div>

        <MDBRow>
          {/* Panel izquierdo: Datos Personales */}
          <MDBCol md="4">
            <PanelDatosPersonales datosPersonales={this.state.datosPersonales} calendarioActivo={this.state.calendarioActivo} condicionesLaborales={this.state.condicionesLaborales} />
          </MDBCol>

          {/* Panel derecho: Acciones */}
          <MDBCol md="8">
            <SelectorDeclaracion
              calendariosActivos={this.state.calendariosActivos}
              calendarioSeleccionadoIdx={this.state.calendarioSeleccionadoIdx}
              onSeleccionar={function(i){ this.setState({ calendarioSeleccionadoIdx: i, calendarioActivo: this.state.calendariosActivos[i] }); }.bind(this)}
            />

            <PanelFirmaDigital
              condicionesLaborales={this.state.condicionesLaborales}
              calendarioActivo={this.state.calendarioActivo}
              descargardocumento={this.state.descargardocumento}
              onVerDocumento={this.accederPDF.bind(this)}
              onFirmarDocumento={this.firmarDocumento}
              informacionregistro={this.state.informacionregistro}
              yaFirmado={this.state.yaFirmadoDB || (this.state.informacionregistro && this.state.informacionregistro.length > 0)}
              usuarioDatoRef={(input) => this.usuarioDato = input}
              onCondicionChange={this.listarCondicionLaboral.bind(this)}
              pdfPreviewUrl={this.state.pdfPreviewUrl}
              pdfFirmadoUrl={this.state.pdfFirmadoUrl}
              firmando={this.state.firmando}
              errorFirma={this.state.errorFirma}
            />
          </MDBCol>
        </MDBRow>

      </MDBContainer>
    )
  }

 componentDidUpdate(prevProps, prevState) {
    var ahora = this.state;
    var antes = prevState;
    // Cargar PDF firmado desde disco cuando yaFirmadoDB o calendarioActivo lleguen (lo que llegue último)
    var recienFirmoDetectado = !antes.yaFirmadoDB && ahora.yaFirmadoDB;
    var recienCalendario     = !antes.calendarioActivo && ahora.calendarioActivo;
    var recienCondiciones    = antes.condicionesLaborales.length === 0 && ahora.condicionesLaborales.length > 0;
    var debeCarga = (recienFirmoDetectado || recienCalendario || recienCondiciones)
                    && ahora.yaFirmadoDB && ahora.calendarioActivo
                    && ahora.condicionesLaborales.length > 0 && !ahora.pdfFirmadoUrl;
    if (debeCarga) {
      var cal = ahora.calendarioActivo;
      var conds = ahora.condicionesLaborales.filter(function(c){ return c.trabajador && c.trabajador.toString().trim() !== ''; });
      var codigoTrabajador = conds.length > 0 ? conds[0].trabajador : '';
      if (!codigoTrabajador) return;
      var autorizacion = '';
      try { autorizacion = this.props.location.state.datos[0].autorizacion; } catch(e) {}
      axios.get(API_URL + '/declaracion/mipdf/', {
        params: { anio: cal.anio, documento: cal.documento, trabajador: codigoTrabajador },
        headers: { authorization: autorizacion },
        responseType: 'blob'
      }).then(function(r) {
        if (r.data && r.data.size > 0) {
          this.setState({ pdfFirmadoUrl: URL.createObjectURL(r.data) });
        }
      }.bind(this)).catch(function(){});
    }
  }

 //metodo component did mount
 //llamar los servicios que se requieran y cargar a los datos
 async componentDidMount(){
  //   Promise.all([
  //     await  fetch(API_URL + '/vinculopdf/18451'),
  //     await  fetch(API_URL + '/cincoultimosperiodos/'),
  //     await  fetch(API_URL + '/planillastrabajadorperiodo/042020/18451')
  // ])
  // .then(([res1, res2, res3]) => Promise.all([res1.json(), res2.json(), res3.json()]))
  // .then(([data1, data2, data3]) => this.setState({
  //     datosPersonales: data1,
  //     periodos: data2,
  //     planillasTrabajador: data3,
  // }))

  //const { trabajador, autorizacion } = this.props.location.state    
    // const trabajador = this.props.location?.state?.datos?.[0]?.trabajador;    
    // if (trabajador && trabajador.length > 0) {
    //   this.setState({ usuario: trabajador });
    // }

    // const auto = this.props.location.state.datos[0].autorizacion;
    // if (auto && auto.length > 0) {
    //   this.setState({ autorizacion: auto });
    // }

    if (
      this.props &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.datos &&
      Array.isArray(this.props.location.state.datos) &&
      this.props.location.state.datos.length > 0 &&
      this.props.location.state.datos[0].trabajador &&
      this.props.location.state.datos[0].trabajador.length > 0
    ) {
      this.setState({
        usuario: this.props.location.state.datos[0].trabajador
      });
    }
  //this.setState({ usuario : this.props.location.state.datos[0].trabajador})
      if (
      this.props &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.datos &&
      Array.isArray(this.props.location.state.datos) &&
      this.props.location.state.datos.length > 0 &&
      this.props.location.state.datos[0].autorizacion &&
      this.props.location.state.datos[0].autorizacion.length > 0
    ) {
      this.setState({        
        autorizacion : this.props.location.state.datos[0].autorizacion
      });
    }
  //this.setState({ autorizacion : this.props.location.state.datos[0].autorizacion})
  
  //console.log(this.props.datos);
  //console.log(this.props.location.state.datos);
  //console.log(this.props.location.state.datos[0].autorizacion);

  var _sd = this.props && this.props.location && this.props.location.state && this.props.location.state.datos && this.props.location.state.datos[0];

  // Verificar si ya firmó para bloquear botones al reingresar a la página
  var workerDniCheck = _sd ? _sd.trabajador : '';
  if (workerDniCheck) {
    axios.post(API_URL + '/trabajador/declaracionespendientes/', { dni: workerDniCheck })
      .then(function(r) {
        var yaFirmo = (r.data || []).some(function(d) { return d.firmado; });
        if (yaFirmo) this.setState({ yaFirmadoDB: true });
      }.bind(this))
      .catch(function(){});
  }

  var miInit = {
                method: 'post',
                credentials: 'same-origin',
                mode: 'cors',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'authorization': _sd ? _sd.autorizacion : '',
                  'usuario': _sd ? _sd.trabajador : ''
                }
               };

  Promise.all([
    fetch(API_URL + '/vinculopdf/', miInit),
    fetch(API_URL + '/cincoultimosperiodos/', miInit),
    fetch(API_URL + '/condicionlaboraldj/', miInit)
    ])
    .then(([res1, res2, res3]) => Promise.all([
      res1.json().catch(function(){ return []; }),
      res2.json().catch(function(){ return []; }),
      res3.json().catch(function(){ return []; })
    ]))
    .then(([data1, data2, data3]) => {
      this.setState({
        datosPersonales: data1,
        periodos: data2,
        condicionesLaborales: data3,
      });
    })
    .then(() => {
      // Cargar calendario activo (pasar DNI para que el backend verifique excepciones individuales)
      var workerDniCal = '';
      try { workerDniCal = this.props.location.state.datos[0].trabajador; } catch(e) {}
      if (!workerDniCal) { try { workerDniCal = JSON.parse(sessionStorage.getItem('datos'))[0].trabajador; } catch(e) {} }
      return axios.post(API_URL + '/calendarioActivo/', workerDniCal ? { dni: workerDniCal } : {});
    })
    .then((response) => {
      var conds = this.state.condicionesLaborales.filter(function(c){ return c.trabajador && c.trabajador.toString().trim() !== ''; });

      if (response.data && response.data.length > 0) {
        // Sistema nuevo: TaDeclaracionJurada tiene calendario activo
        this.setState({ calendariosActivos: response.data, calendarioActivo: response.data[0] }, () => {
          var cal = this.state.calendarioActivo;
          var habilitada = false;
          var condHabilitada = null;
          if (cal && cal.excepcion) {
            // Excepcion individual habilitada por admin: saltar verificacion de condiciones
            habilitada = true;
            condHabilitada = conds.length > 0 ? conds[0] : null;
          } else if (cal && cal.observacion && cal.observacion.trim()) {
            // Calendario por tipo de planilla
            var tiposHabilitados = cal.observacion.trim().split(',').map(function(t){ return t.trim(); });
            for (var i = 0; i < conds.length; i++) {
              if (conds[i].nombre) {
                var tipoPlanilla = conds[i].nombre.split('-')[0].trim();
                if (tiposHabilitados.indexOf(tipoPlanilla) >= 0) {
                  habilitada = true;
                  condHabilitada = conds[i];
                  break;
                }
              }
            }
          } else if (cal) {
            // Calendario por trabajadores individuales: verificar en backend con DNI
            var workerDniVerif = '';
            try { workerDniVerif = this.props.location.state.datos[0].trabajador; } catch(e) {}
            if (!workerDniVerif) { try { workerDniVerif = JSON.parse(sessionStorage.getItem('datos'))[0].trabajador; } catch(e) {} }
            if (workerDniVerif) {
              axios.post(API_URL + '/trabajador/verificarcalendario/', { dni: workerDniVerif })
                .then(function(vResp) {
                  if (vResp.data && vResp.data.habilitado) {
                    var condH = conds.find(function(c){ var t=(c.nombre||'').split('-')[0].trim().toUpperCase(); return t==='DOA'||t==='DOC'; }) || (conds.length > 0 ? conds[0] : null);
                    if (condH) {
                      var miInitV = { method: 'post', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' }, body: JSON.stringify({ usuario: condH.trabajador }) };
                      axios.post(API_URL + '/vinculopdfuno/', miInitV).then(function(resp){ this.setState({ datosPersonales: resp.data }); }.bind(this)).catch(function(){});
                    }
                    this.setState({ descargardocumento: true, direcciondearchivo: true });
                  }
                }.bind(this))
                .catch(function(){});
              return;
            }
          }
          if (habilitada && condHabilitada) {
            var miInitAuto = { method: 'post', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' }, body: JSON.stringify({ usuario: condHabilitada.trabajador }) };
            axios.post(API_URL + '/vinculopdfuno/', miInitAuto).then(function(resp){ this.setState({ datosPersonales: resp.data }); }.bind(this)).catch(function(){});
          }
          this.setState({ descargardocumento: habilitada, direcciondearchivo: habilitada });
        });
      } else {
        // Fallback sistema viejo: Personal.dbo.calendario (activo via web_recuperarvinculos)
        // web_recuperarvinculos ya validó que el trabajador es elegible.
        // Las filas sin trabajador tienen aniod/documentod del calendario viejo.
        var calRows = this.state.condicionesLaborales.filter(function(c){ return !c.trabajador || c.trabajador.toString().trim() === ''; });
        if (conds.length > 0 && calRows.length > 0 && calRows[0].aniod && calRows[0].documentod) {
          var calViejo = { anio: calRows[0].aniod, documento: calRows[0].documentod, observacion: '', descripcion: '' };
          var condHabilitadaViejo = conds.find(function(c){ var t=(c.nombre||'').split('-')[0].trim().toUpperCase(); return t==='DOA'||t==='DOC'; }) || conds[0];
          var miInitVieux = { method: 'post', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' }, body: JSON.stringify({ usuario: condHabilitadaViejo.trabajador }) };
          axios.post(API_URL + '/vinculopdfuno/', miInitVieux).then(function(resp){ this.setState({ datosPersonales: resp.data }); }.bind(this)).catch(function(){});
          this.setState({ calendariosActivos: [calViejo], calendarioActivo: calViejo, descargardocumento: true, direcciondearchivo: true });
        }
      }
    })
    .catch((error) => {
      console.error('Error al cargar datos:', error);
    })
 }
}
export default DeclaracionesJuradas;




